<template>
  <div class="km__modules__basicContactForm">
    <button class="km__button--back" type="button" name="back" @click="$emit('close')" aria-label="back"></button>
    <button class="km__button--close" type="button" name="close" @click="$emit('close')" aria-label="close"></button>
    <div class="km__popup--content">
      <ul class="km__list--modules">
        <li class="km__list__element--modules">
          <label class="km__label--text">{{ $t("konf_Vorname") }}</label>
          <input class="km__input--standard" type="text" v-model="vorname" :class="{error:hasError('vorname')}">
        </li>
        <li class="km__list__element--modules">
          <label class="km__label--text">{{ $t("konf_Nachname") }}</label>
          <input class="km__input--standard" type="text" v-model="nachname" :class="{error:hasError('nachname')}">
        </li>
        <li class="km__list__element--modules">
          <label class="km__label--text">{{ $t("konf_contact_body") }}</label>
          <textarea class="km__input--area" cols="30" rows="4" v-model="message"
                    :class="{error:hasError('message')}"></textarea>
        </li>
        <li class="km__list__element--modules">
          <p class="no-padding">{{ $t("konf_contact_how") }}</p>
        </li>
        <li class="km__list__element--modules">
          <label class="km__label--text">{{ $t("konf_Email_required") }}</label>
          <input class="km__input--standard" type="text" v-model="email" :class="{error:hasError('email')}">
        </li>
        <li class="km__list__element--modules">
          <label class="km__label--text">{{ $t("konf_Tel") }}</label>
          <input class="km__input--standard" type="text" v-model="telefon">
        </li>
        <li class="km__list__element--modules">
          <div class="datenschutz">
            <input type="checkbox" v-model="acceptPrivacyTerms" :class="{error:hasError('privacyTerms')}">
            <label class="km__label--text" :class="{error:hasError('acceptPrivacyTerms')}">
              <span>{{ $t("km_accept-privacyterms_prelink") }} <a :href="datenschutzlink"
                                                               target="_blank">{{ $t('km_accept-privacyterms_linktext') }}</a>
                {{ $t("km_accept-privacyterms_postlink") }}</span>
            </label>
          </div>
        </li>
      </ul>
    </div>
    <div class="km__popup--buttons">
      <button class="km__button--standard blue" @click="sendToParent">{{ $t("konf_Submit") }}</button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {computed, ref, Ref} from "vue";
import {LinksToWebsite} from "@k/js/databaseInterfaceClasses";
import {useStore} from "vuex";
import {checkEmail} from "@k/global/globalUtils";
import type {BasicContactFormData} from "@km/components/popups/BasicContactFormData";
import globalsObject from "@k/js/globalsObject";
import {LOOPTRACKINGEVENTNAMES} from "@k/global/loopTracker";


const emit = defineEmits(["send", "close"]);

function validate(formdata: BasicContactFormData): string[] {
  const errors = [] as string[];
  if (formdata.vorname.value + formdata.nachname.value === "") {
    errors.push("vorname");
    errors.push("nachname");
  }
  if (checkEmail(formdata.email.value) !== "valid") {
    errors.push("email");
  }
  if (formdata.message.value.trim() === "") {
    errors.push("message");
  }
  if (!formdata.acceptPrivacyTerms.value) {
    errors.push("acceptPrivacyTerms");
  }
  return errors;
}


const store = useStore();
const formdata = {
  vorname: ref(""),
  nachname: ref(""),
  message: ref(""),
  email: ref(""),
  telefon: ref(""),
  acceptPrivacyTerms: ref(false),
} as BasicContactFormData;

const errors = ref([]) as Ref<string[]>

const vorname = formdata.vorname;
const nachname = formdata.nachname;
const message = formdata.message;
const email = formdata.email;
const telefon = formdata.telefon;
const acceptPrivacyTerms = formdata.acceptPrivacyTerms;
const hasError = (name:string) => errors.value.indexOf(name) > -1;
const datenschutzlink = computed(() => store.getters["ModelStore/getLinkToWebsite"](LinksToWebsite.privacyterms));
const sendToParent = () => {
  globalsObject.loopTracker.trackBasicEvent(LOOPTRACKINGEVENTNAMES.KONFI_SUBMIT_DESIGNCHECK);
  errors.value = validate(formdata);
  if (errors.value.length === 0) {
    emit('send', formdata)
  }
};

</script>

<style scoped lang="scss">
@use "../../scss/settings/config" as config;

.km__modules__basicContactForm {
  .km__list__element--modules {
    margin-bottom: 20px;

    .no-padding {
      padding-top: 15px;
      margin-bottom: 0;
    }
  }

  .km__label--text {
    margin-bottom: 5px;
  }

  strong {
    font-weight: 600;
  }

  p {
    a {
      color: config.$color-black;
      text-decoration: underline;
    }
  }

  .datenschutz {
    .km__label--text {
      font-weight: normal;

      &.error {
        color: red;

        p {
          a {
            color: red;
          }
        }
      }
    }
  }
}
</style>
